import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Carousel from 'nuka-carousel';

import Container from './container';
import Top from '../top';
import Button from './button';

const StyledPrograms = styled.section`
	position: relative;
	background-image: url('${(p) => p.background}');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	padding: 3rem 0;
	transition: background-image 300ms;

.carousel-wrap {
		width: 70%;
		margin: 2rem auto 0;

	.slider {
		.slider-list {
			.slider-slide {
				top: 50% !important;
				transform: scale(1) translateY(-50%) !important;

				.programs-slide-inner {
					color: ${(p) => p.theme.color.light};
					text-align: center;

					img {
						width: 150px;
						margin: 0 auto 1.5rem;
					}

					p {
						line-height: 1.5;
						margin: 0 auto 1.5rem;
						max-width: 600px;
					}
				}
			}
		}
		
		.slider-control-centerright {
			right: -1.5rem !important;

			img {
				width: 1rem;
			}
		}

		.slider-control-centerleft {
			left: -1.5rem !important;

			img {
				width: 1rem;
			}
		}
	}
}

`;

const ProgramsCarousel = () => {
	const data = useStaticQuery(graphql`
		query ProgramsCarouselQuery {
			allProgramsJson(sort: { fields: order, order: ASC }) {
				edges {
					node {
						programTitle
						background
						logo {
							src
							alt
						}
						copy
						link
					}
				}
			}
		}
	`);

	const { edges: programs } = data.allProgramsJson;
	const [bgImg, setBgImg] = useState(`${programs[0].node.background}`);

	return (
		<StyledPrograms background={bgImg}>
			<Container>
				<div className="carousel-wrap">
					<Carousel
						autoplay={false}
						autoplayInterval={7000}
						wrapAround={true}
						heightMode={'max'}
						initialSlideHeight={200}
						afterSlide={(currentSlide) =>
							setBgImg(`${programs[currentSlide].node.background}`)
						}
						renderBottomCenterControls={() => null}
						renderCenterLeftControls={({ previousSlide }) => (
							<button aria-label="previous slide" onClick={previousSlide}>
								<img src="/img/chevron-left-white.svg" alt="chevron left" />
							</button>
						)}
						renderCenterRightControls={({ nextSlide }) => (
							<button aria-label="next slide" onClick={nextSlide}>
								<img src="/img/chevron-right-white.svg" alt="chevron right" />
							</button>
						)}
					>
						{programs.map(({ node: program }, i) => (
							<div
								className={'programs-slide-inner'}
								key={`${program.programTitle}-${i}`}
							>
								<Top color="light">PROGRAMS</Top>
								{program.logo ? (
									<>
										<h2 className="hide">{program.programTitle}</h2>
										<img src={program.logo.src} alt={program.logo.alt} />
									</>
								) : (
									<h2>{program.programTitle}</h2>
								)}
								<p>{program.copy}</p>
								<Button type="link" bg="white" to={program.link}>
									SIGN UP
								</Button>
							</div>
						))}
					</Carousel>
				</div>
			</Container>
		</StyledPrograms>
	);
};

export default ProgramsCarousel;
